// Ponto unico de importacao do AmarelinhoService.
//
// No build do ambiente audio (REACT_APP_ENV=audio) entra a versao falsa, que
// nao valida nem grava nada; nos demais, a real. Ver audioTestMode.ts.

import AmarelinhoServiceFake from './AmarelinhoService.fake';
import AmarelinhoServiceReal from './AmarelinhoService.real';
import { AUDIO_TEST_MODE } from './audioTestMode';

const AmarelinhoService = AUDIO_TEST_MODE ? AmarelinhoServiceFake : AmarelinhoServiceReal;

export default AmarelinhoService;
